import { useMemo, useRef } from "react";
import isObject from "lodash/isObject";
import debounce from "lodash/debounce";
import usePersist from "./usePersist";
import useUnmount from "./useUnmount";
import useLatestRef from "./useLatestRef";
function useDebounce(callback, options) {
  var wait = 0;
  var maxWait = Infinity;
  var leading = false;
  var trailing = true;
  if (typeof options === "number") {
    wait = options;
  } else if (isObject(options)) {
    if (options.wait !== undefined) {
      wait = +options.wait;
    }
    if (options.maxWait !== undefined) {
      maxWait = +options.maxWait;
    }
    if (options.leading !== undefined) {
      leading = !!options.leading;
    }
    if (options.trailing !== undefined) {
      trailing = !!options.trailing;
    }
  }
  var callbackRef = useLatestRef(callback);
  var debouncedRef = useRef();
  useMemo(function () {
    var _debouncedRef$current;
    (_debouncedRef$current = debouncedRef.current) === null || _debouncedRef$current === void 0 ? void 0 : _debouncedRef$current.flush();
    debouncedRef.current = debounce(function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      // @ts-ignore
      return callbackRef.current.apply(this, args);
    }, wait, {
      maxWait: maxWait,
      leading: leading,
      trailing: trailing
    });
  }, [wait, maxWait, leading, trailing] // eslint-disable-line
  );

  var debounced = usePersist(function () {
    var _debouncedRef$current2;
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    // @ts-ignore
    return (_debouncedRef$current2 = debouncedRef.current) === null || _debouncedRef$current2 === void 0 ? void 0 : _debouncedRef$current2.apply(this, args);
  });
  var flush = usePersist(function () {
    var _debouncedRef$current3;
    return (_debouncedRef$current3 = debouncedRef.current) === null || _debouncedRef$current3 === void 0 ? void 0 : _debouncedRef$current3.flush();
  });
  var cancel = usePersist(function () {
    var _debouncedRef$current4;
    (_debouncedRef$current4 = debouncedRef.current) === null || _debouncedRef$current4 === void 0 ? void 0 : _debouncedRef$current4.cancel();
  });
  useUnmount(cancel);
  return [debounced, {
    flush: flush,
    cancel: cancel
  }];
}
export default useDebounce;